'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import { useInstantSearch } from 'react-instantsearch';
import { ALGOLIA_INDEX_NAME, ALGOLIA_PRODUCT_INDEXES } from 'commons/constants';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import SectionButtons from './components/SectionButtons';
import WidthRangeFilter from '../WidthRangeFilter';
import ClearAllFiltersButtonComponent from '../ClearAllFiltersButton';
import ProductTypeRefinementList from './components/ProductTypeRefinementList';
const countForIndex = (scopedResults, indexName) => {
  const match = scopedResults?.find(entry => entry.indexId === indexName || entry.indexName === indexName);
  const count = match?.results?.nbHits;
  return Number.isFinite(count) ? count : '';
};

/**
 * Desktop sidebar UI. Kept mounted and hidden with CSS on small screens.
 */
const AdvancedSearchSidebar = t0 => {
  const $ = _c(51);
  const {
    isOpen: t1
  } = t0;
  const isOpen = t1 === undefined ? true : t1;
  const {
    currentSearchSection,
    updateSearchSection,
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  const {
    results,
    scopedResults
  } = useInstantSearch();
  let t2;
  if ($[0] !== currentSearchSection) {
    t2 = ALGOLIA_PRODUCT_INDEXES.includes(currentSearchSection);
    $[0] = currentSearchSection;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const showProductFilters = t2;
  const t3 = !isOpen;
  let t4;
  if ($[2] !== isOpen || $[3] !== t3) {
    t4 = classNames("hidden md:block sticky overflow-x-hidden transition-[all_0.22s_ease-in-out] max-h-full lg:max-h-[calc(100vh_-_3.75rem_-_53px)] top-[20px] lg:top-[calc(3.75rem_+_53px)] self-start", {
      "opacity-100 w-[140px] min-w-[140px] lg:w-[240px] lg:min-w-[240px]": isOpen,
      "opacity-0 w-0 min-w-0": t3
    });
    $[2] = isOpen;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="text-base font-bold text-gray px-0 py-4">Refine by:</h2>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== updateSearchSection) {
    t6 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.PRODUCTS);
    };
    $[6] = updateSearchSection;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = currentSearchSection === ALGOLIA_INDEX_NAME.PRODUCTS;
  let t8;
  if ($[8] !== results) {
    t8 = Number.isFinite(results?.nbHits) ? results.nbHits : "";
    $[8] = results;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t9 = <SectionButtons title="Products" onClick={t6} active={t7} countOverride={t8} />;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== updateSearchSection) {
    t10 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS);
    };
    $[14] = updateSearchSection;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = currentSearchSection === ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS;
  let t12;
  if ($[16] !== scopedResults) {
    t12 = countForIndex(scopedResults, ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS);
    $[16] = scopedResults;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12) {
    t13 = <SectionButtons title="Customer Photos" onClick={t10} active={t11} countOverride={t12} />;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== updateSearchSection) {
    t14 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.REVIEWS);
    };
    $[22] = updateSearchSection;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = currentSearchSection === ALGOLIA_INDEX_NAME.REVIEWS;
  let t16;
  if ($[24] !== scopedResults) {
    t16 = countForIndex(scopedResults, ALGOLIA_INDEX_NAME.REVIEWS);
    $[24] = scopedResults;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t16) {
    t17 = <SectionButtons title="Reviews" onClick={t14} active={t15} countOverride={t16} />;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== updateSearchSection) {
    t18 = () => {
      updateSearchSection?.(ALGOLIA_INDEX_NAME.STATIC_PAGES);
    };
    $[30] = updateSearchSection;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const t19 = currentSearchSection === ALGOLIA_INDEX_NAME.STATIC_PAGES;
  let t20;
  if ($[32] !== scopedResults) {
    t20 = countForIndex(scopedResults, ALGOLIA_INDEX_NAME.STATIC_PAGES);
    $[32] = scopedResults;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t18 || $[35] !== t19 || $[36] !== t20) {
    t21 = <SectionButtons title="Pages" onClick={t18} active={t19} countOverride={t20} />;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== handleToggleReadyToShip || $[39] !== isReadyToShipActive || $[40] !== showProductFilters) {
    t22 = showProductFilters && <><div className="mt-4"><ClearAllFiltersButtonComponent /></div><div className="mt-4"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} /></div><div className="mt-4"><WidthRangeFilter showTitle={true} /></div><div><h3 className="text-base font-bold mb-2 mt-4">Product Type</h3><ProductTypeRefinementList /></div></>;
    $[38] = handleToggleReadyToShip;
    $[39] = isReadyToShipActive;
    $[40] = showProductFilters;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t13 || $[43] !== t17 || $[44] !== t21 || $[45] !== t22 || $[46] !== t9) {
    t23 = <div className="pr-6 w-[140px] min-w-[140px] lg:w-[240px] lg:min-w-[240px]">{t5}{t9}{t13}{t17}{t21}{t22}</div>;
    $[42] = t13;
    $[43] = t17;
    $[44] = t21;
    $[45] = t22;
    $[46] = t9;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t23 || $[49] !== t4) {
    t24 = <div className={t4} data-xc="ProductListingDesktopSidebar">{t23}</div>;
    $[48] = t23;
    $[49] = t4;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  return t24;
};
export default AdvancedSearchSidebar;